<template>
  <li class="contact-item">
    <a 
      v-if="type === 'url' || type === 'email' || type === 'tel'"
      :href="link"
      target="_blank"
      rel="noopener noreferrer"
      class="contact-link"
    >
      <i :class="icon" class="contact-icon"></i>
      <span class="contact-value">{{ value || $t('noContactAvailable') }}</span>
    </a>
    <div v-else class="contact-link">
      <i :class="icon" class="contact-icon"></i>
      <span class="contact-value">{{ value || $t('noContactAvailable') }}</span>
    </div>
  </li>
</template>

<script>
export default {
  name: 'ContactItem',
  props: {
    icon: {
      type: String,
      required: true
    },
    value: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: '#'
    },
    type: {
      type: String,
      validator: (value) => ['email', 'tel', 'url', 'location'].includes(value)
    }
  }
}
</script>

<style scoped>
.contact-item {
  @apply w-full;
}

.contact-link {
  @apply flex items-center justify-center p-4 transition-colors;
  background: white;
  border: 2px solid #144A78;
  color: #1a1a1a;
  min-height: 3.5rem;
  border-radius: 0.5rem;
  width: 100%;
  max-width: 400px;
  margin: 0 auto 0.5rem auto;
}
.contact-link:hover {
  background-color: #f0f7ff;
  border-color: #0f3a5f;
}

.contact-icon {
  @apply mr-3 min-w-[1.5rem] text-center text-lg;
  color: #144A78;
  flex-shrink: 0;
}

.contact-value {
  @apply whitespace-nowrap overflow-hidden overflow-ellipsis;
  color: #374151;
  flex-grow: 1;
  text-align: left;
  min-width: 0;
}

@media (min-width: 640px) {
  .contact-link {
    min-height: 4rem;
    padding: 1rem 1.5rem;
  }
}

@media (min-width: 1024px) {
  .contact-link {
    max-width: 1000px;
  }
}
</style>